
<template>
  <base-info-card-marker @click="handleClick" :marker_color="project.json_attributes.color">
    <template slot="icon">
      <v-col cols="12" sm="3" md="3" class="pa-0">
        <span class="mx-1 ">#{{project.id}}</span>
        <span class="mx-1 black--text ">{{project.name}}</span>

      </v-col>
    </template>


    <template slot="text">
      <v-col cols="12" sm="5" md="5" class="pa-0 ml-sm-4 my-2 my-sm-0 black--text">
        <b class=""> {{ $t('projects.kind') }}:</b>
        <span class="ml-2">{{ project.kind }}</span>

        
        <v-row class="px-3 black--text" align='center' v-if="false">
          
          <v-col class="pa-0" v-if="false">
            <v-row class="px-3" align='center' >
              <!-- Status  -->
            </v-row>
          </v-col>
  
          <v-col cols="3" class="pa-0">
            <b class="ml-4"> {{ $t('stages.stages') }}: </b>
            <span>{{ project.stage_count }}</span>
          </v-col>
  
        </v-row>
      </v-col>
    </template>



    <template slot="last">
      <v-col class="pa-0 ml-0 ml-sm-4 black--text" align='right'>
        <b> {{ $t('stages.stages') }}: </b>
        <span class="mr-0 mr-sm-10">{{ project.stage_count }}</span>
        <span class="black--text">
          Conclusão: 
          <b>
            <span>{{ project.all_stages_expected_duration }} {{ $tc('day', 2) }}</span>
          </b>
        </span>
      </v-col>
    </template>
  </base-info-card-marker>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'TemplateSmallCard',
  //mixins: [ validations ],
  props: {
    project: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', {...e, project_id: this.project.id})
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>